<div edlFocusTrap class="focus-trap-container">
<div class="modal-header">
    <h4 class="modal-title">Notes</h4>
</div>
<div class="modal-body evidence">
    <edl-notes
        [typeOfNote]="typeOfNote"
        [typeId]="typeId"
        [notesToInclude]="notesToInclude"
        [isReadOnly]="isReadOnly">
    </edl-notes>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-info" (click)="activeModal.close()">Close</button>
</div>
</div>
